import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllCategories, fetchProductsByCategory } from './categoryServices';
import {
  GetAllCategoriesParams,
  GetAllCategoriesResponse,
  GetProductsByCategoryParams,
  GetProductsByCategoryResponse,
} from './categoryModels';

/**
 * Async thunk for fetching all categories
 */
export const getAllCategories = createAsyncThunk<
  GetAllCategoriesResponse,
  GetAllCategoriesParams | undefined,
  { rejectValue: string }
>(
  'categories/getAllCategories',
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await fetchAllCategories(params);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch categories'
      );
    }
  }
);

/**
 * Async thunk for fetching products by category
 */
export const getProductsByCategory = createAsyncThunk<
  GetProductsByCategoryResponse,
  { categoryId: string; params?: GetProductsByCategoryParams },
  { rejectValue: string }
>(
  'categories/getProductsByCategory',
  async ({ categoryId, params = {} }, { rejectWithValue }) => {
    try {
      const data = await fetchProductsByCategory(categoryId, params);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch products by category'
      );
    }
  }
);

